import { module } from "angular";
import { SearchResultGroupComponent } from "./SearchResultGroupComponent";

module("mmGui").component("irSearchResultGroup", new SearchResultGroupComponent());
